export { default } from "www/pages/privacy_policy/PrivacyPolicy";